'use client';

import { useSectionActivation, type UseSectionActivationOptions } from './use-section-activation';
interface SectionActivationProps {
  sections: string[];
  options?: UseSectionActivationOptions;
}
function SectionActivation(t0) {
  const {
    sections,
    options
  } = t0;
  useSectionActivation(sections, options);
  return null;
}
export { SectionActivation };